import './acl';

Shopware.Component.override('sw-cms-detail', () => import('./page/sw-cms-detail/block-rule'));
Shopware.Component.override('sw-cms-detail', () => import('./page/sw-cms-detail/quickview'));
Shopware.Component.override('sw-cms-detail', () => import('./page/sw-cms-detail/form-builder'));
Shopware.Component.override('sw-cms-detail', () => import('./page/sw-cms-detail/scroll-navigation'));
Shopware.Component.override('sw-cms-list', () => import('./page/sw-cms-list'));

Shopware.Component.override('sw-cms-page-form', () => import('./component/sw-cms-page-form'));
Shopware.Component.override('sw-cms-section-actions', () => import('./component/sw-cms-section-actions'));
Shopware.Component.override('sw-cms-section-config', () => import('./component/sw-cms-section-config'));
Shopware.Component.override('sw-cms-sidebar', () => import('./component/sw-cms-sidebar'));
Shopware.Component.override('sw-cms-sidebar-nav-element', () => import('./component/sw-cms-sidebar-nav-element'));
Shopware.Component.override('sw-cms-slot', () => import('./component/sw-cms-slot'));
